module.exports = __webpack_public_path__ + "media/images/favicon-5a6e8f8dd085d2d90e305ef99744b0db.png";